<div class="margin-top-15">
    <router-outlet></router-outlet>
</div>
